import { useContext } from "react";
import SentimentDriversTable from "../../../Component/BrandIndexHistory/SentimentDrivers";
import { transformDriverData } from "../../../utils/helpers";
import { DiscoveryContext } from "../discovery-context";

export default function SentimentDrivers({
  selectedCompetitor = 0,
  isSelectedMarket = false,
  id="Sentiment_Drivers"
}) {
  /* it's a unique id which we use to identify our component*/
  const discoveryCtx = useContext(DiscoveryContext);
  const selectedLLM = discoveryCtx.state.selectedLLM;
  const selectedCategory = discoveryCtx.state.selectedCategory;
  const selectedMarket = discoveryCtx.state.selectdMarket;
  
  let market = discoveryCtx.markets[0];
  let data;
  if (isSelectedMarket) {
    data =
      discoveryCtx.brand_scores[selectedLLM][selectedCategory][
        selectedMarket
      ]?.[0]?.extras;
  } else {
    data =
      discoveryCtx.brand_scores[selectedLLM][selectedCategory][market]?.[
        selectedCompetitor
      ]?.extras;
  }
  console.log("discoveryCtx",discoveryCtx,data,selectedLLM,selectedCategory,market,selectedCompetitor)
  return (
    <>
      {data?.sentiementKeyDrivers &&
        Object.keys(data.sentiementKeyDrivers).length > 0 && (
          <>
         
            <hr />
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "0.5rem",
              }}
              id={id}
            >
              {data.sentiementKeyDrivers?.positive &&
                data.sentiementKeyDrivers?.positive.length > 0 && (
                  <div style={{ flex: 1, minWidth: "40%" }}>
                    <SentimentDriversTable
                      data={transformDriverData(
                        data.sentiementKeyDrivers?.positive,
                        "Positive"
                      )}
                      title="Positive Sentiment Drivers"
                    />
                  </div>
                )}

              {data.sentiementKeyDrivers?.negative &&
                data.sentiementKeyDrivers?.negative.length > 0 && (
                  <div style={{ flex: 1, minWidth: "40%" }}>
                    <SentimentDriversTable
                      data={transformDriverData(
                        data.sentiementKeyDrivers?.negative,
                        "Negative"
                      )}
                      title="Negative Sentiment Drivers"
                    />
                  </div>
                )}
            </div>
          </>
        )}
    </>
  );
}
